(function () {
    "use strict";
    
    const selectors = {
        newsList: '#newsListing',
        newsItems: '.csh-aem-base-news-listing__item',
        loadButton: '#loadmore',
    };

    document.addEventListener("DOMContentLoaded", function () {
        const newsList = document.querySelector(selectors.newsList);
        
        // If no news list is found, exit the function
        if (!newsList) {
            console.warn('No news listing found on the page.');
            return;
        }

        const newsItems = Array.from(newsList.querySelectorAll(selectors.newsItems));
        const loadButton = document.querySelector(selectors.loadButton);

        // If no load button is found, log a warning and exit
        if (!loadButton) {
            console.warn('No load button found on the page.');
            return;
        }

        const maxItems = 6;
        const loadItems = 6;
        const hiddenClass = "hiddenStyle";

        // Initially hide the load button
        loadButton.style.display = "none";

        // Hide news items beyond the maxItems limit
        newsItems.forEach((item, index) => {
            if (index >= maxItems) {
                item.classList.add(hiddenClass);
                loadButton.style.display = "block"; // Show the load button if there are hidden items
            }
        });

        // Add click event listener to the load button
        loadButton.addEventListener("click", function () {
            const hiddenItems = document.querySelectorAll("." + hiddenClass);
            hiddenItems.forEach((item, index) => {
                if (index < loadItems) {
                    item.classList.remove(hiddenClass);
                }
            });

            // Hide the load button if there are no more hidden items
            if (document.querySelectorAll("." + hiddenClass).length === 0) {
                loadButton.style.display = "none";
            }
        });
    });
}());
